import React from "react";
// import Facilities from "./Facilities/Facilities";
import "./Facility.css";
import CS from "../../../images/customer-care-illustration-concept_42694-26.jpg";
import location from "../../../images/address-concept-illustration_114360-321.jpg";
import contact from "../../../images/5d2d955df2895ca18dec554b0e716042.jpg";

// const facility = [
//   {
//     title: "24*7 Customer Services",
//     image: <i className="bi biTools"></i>,
//     desc: " 009854555568",
//   },
//   {
//     title: "Visit Our Location",
//     image: <i className="bi bi-tools"></i>,
//     desc: "Chittagong, Bangladesh",
//   },
//   {
//     title: "Contact Us Now",
//     image: <i className="bi bi-tools"></i>,
//     desc: "info@carservice.com",
//   },
// ];

const Facility = () => {
  return (
    <>
      <h1 className="text-center pt-3 pb-3">FACILITIES WE PROVIDE</h1>
      <div class="container">
        <div class="cardFacility">
          <div class="face face1">
            <div class="content">
              <img
                src="https://github.com/Jhonierpc/WebDevelopment/blob/master/CSS%20Card%20Hover%20Effects/img/design_128.png?raw=true"
                alt=""
              />
              <h3>Design</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas
                cum cumque minus iste veritatis provident at.
              </p>
              <a href="#">Read More</a>
            </div>
          </div>
        </div>
        <div class="cardFacility">
          <div class="face face1">
            <div class="content">
              <img
                src="https://github.com/Jhonierpc/WebDevelopment/blob/master/CSS%20Card%20Hover%20Effects/img/code_128.png?raw=true"
                alt=""
              />
              <h3>Code</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas
                cum cumque minus iste veritatis provident at.
              </p>
              <a href="#">Read More</a>
            </div>
          </div>
        </div>
        <div class="cardFacility">
          <div class="face face1">
            <div class="content">
              <img
                src="https://github.com/Jhonierpc/WebDevelopment/blob/master/CSS%20Card%20Hover%20Effects/img/launch_128.png?raw=true"
                alt=""
              />
              <h3>Launch</h3>
            </div>
          </div>
          <div class="face face2">
            <div class="content">
              <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas
                cum cumque minus iste veritatis provident at.
              </p>
              <a href="#">Read More</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Facility;
